import type { IconData } from '@stacksjs/iconify-core'

export const log: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M44 22H30m-5 13h-9m28.5-4H39M10 15l9-.5l-1.765-6.001c-.401-1.363.417-2.795 1.831-2.935c.39-.04.794-.064 1.184-.064c.562 0 1.15.052 1.69.122c1.329.172 2.443 1.03 3.123 2.185L29 14.5l9 .5c3.866 0 7 5.82 7 13s-3.134 13-7 13c0 0-5 .5-14 .5S10 41 10 41\"/><path d=\"M17 28c0 7.18-3.134 13-7 13s-7-5.82-7-13s3.134-13 7-13s7 5.82 7 13\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default log
